import React, { useState, useEffect } from 'react';
import '../css/tableGrid.css';

import { Link } from 'react-router-dom';

import { useLocation, useNavigate } from 'react-router-dom';

const TableGrid = ({ gridDataValue, gridDataColumnsValue }) => {
  console.log("In TableGrid11::")
  const gridDataValueDisp= gridDataValue;
  const gridDataColumnsValueDisp = gridDataColumnsValue;
  return (
    <div className="table-grid-container">
      {gridDataValueDisp.length === 0 ? (
        <div className="no-records-message">
          <p>There are no records.</p>
        </div>
      ) : (
          <table className="table-grid">
            <thead>
              <tr>

                {gridDataColumnsValueDisp.map((column) => (
                  <th key={column}>{column}</th>
                ))}

              </tr>
            </thead>
            <tbody>
              {gridDataValueDisp.map((item) => (
                <tr key={item[0]}>
                  {item.map((columnValue, columnIndex) => {
                    const columnName = gridDataColumnsValueDisp[columnIndex];
                    if (columnName) {
                      console.log("columnValue::", columnValue)
                      if (typeof columnValue == 'object') {
                        console.log("setcolumnValue::11", columnValue)
                        columnValue = '';
                        console.log("setcolumnValue::22", columnValue)
                      }
                      // If a column name exists, render it in the corresponding column
                      return <td key={columnName}>{columnValue}</td>;
                    } else {
                      // If no column name exists, render the data in a separate column
                      return <td key={`extra-${columnIndex}`}>{columnValue}</td>;
                    }
                  })}

                </tr>
              ))}
            </tbody>
          </table>
        )}
    </div>
  );
};


const DataTableGrid = ({ gridData, gridDataColumns, nodeData, dataTableDroppedNodes,
  connectionNameValue, connectionTypeValue, reportName, catalogs, schemas, tables, columns }) => {

  const navigate = useNavigate();
  const location = useLocation();

  console.log(JSON.stringify(location.state) + "location.state--------------");

  let selectedTableColumnsValue = '';
  let selectedTableColumnsRightListValue = '';

  let connectionName = '';
  let connectionType = '';
  let reportNameValue = '';
  let gridDataValue = '';
  let gridDataColumnsValue = '';

  let catalogsList = '';
  let schemasList = '';
  let tablesList = '';
  let columnsList = '';

  if (location.state && location.state.nodeData !== undefined) {
    const { gridData, gridDataColumns, nodeData, dataTableDroppedNodes,
      connectionNameValue, connectionTypeValue, reportName,
      catalogs, schemas, tables, columns } = location.state;

    console.log(JSON.stringify(nodeData) + "nodeData");
    console.log(dataTableDroppedNodes);
    console.log(connectionNameValue + "connectionNameValue");
    console.log(reportName + "reportName");

    console.log(JSON.stringify(gridDataColumns) + "gridDataColumns2");
    console.log(JSON.stringify(gridData.length) + "gridDataLENGTH");


    connectionName = connectionNameValue;
    reportNameValue = reportName;
    gridDataValue = gridData;
    gridDataColumnsValue = gridDataColumns;

    catalogsList = location.state.catalogDataList;
    schemasList = location.state.schemaDataList;
    tablesList = location.state.tableDataList;
    columnsList = location.state.columnDataList;
    connectionType = connectionTypeValue;

    console.log(JSON.stringify(catalogsList) + "catalogsList");
    console.log(JSON.stringify(schemasList) + "schemasList");
    console.log(JSON.stringify(tablesList) + "tablesList");
    console.log(JSON.stringify(columnsList) + "columnsList");


  } else {

    console.log(JSON.stringify(nodeData) + "nodeData");
    console.log(dataTableDroppedNodes + "dataTableDroppedNodes");
    console.log(connectionNameValue + "connectionNameValue");
    console.log(JSON.stringify(connectionName) + "connectionName");
    console.log(JSON.stringify(reportName) + "reportName");
    console.log("gridData::1",JSON.stringify(gridData));

    connectionName = connectionNameValue;
    connectionType = connectionTypeValue;
    reportNameValue = reportName;
    gridDataValue = gridData;
    
    if (JSON.stringify(gridData).includes("requestBody")){
      gridDataValue = gridData["data"]; 
    }
    
    console.log("getGriddata::2", gridData["data"], JSON.stringify(gridData).includes("requestBody"))
    gridDataColumnsValue = gridDataColumns;

    catalogsList = catalogs;
    schemasList = schemas;
    tablesList = tables;
    columnsList = columns;

    console.log(JSON.stringify(catalogsList) + "catalogsList");
    console.log(JSON.stringify(schemasList) + "schemasList");
    console.log(JSON.stringify(tablesList) + "tablesList");
    console.log(JSON.stringify(columnsList) + "columnsList");
    console.log(JSON.stringify(selectedTableColumnsRightListValue) + "selectedTableColumnsRightList");
    // console.log(JSON.stringify(rightListColumnsValue) + "rightListColumnsValue");
    console.log(JSON.stringify(gridDataValue) + "gridDataValue");
    console.log(JSON.stringify(gridDataColumnsValue) + "gridDataColumnsValue");

  }

  return (
    <div className="grid-data">

      {location.state && location.state.nodeData !== undefined ? (
        <>
          <h2>Connection Name : {connectionName}</h2>
          <h3>Report Name : {reportNameValue}</h3>
          <Link to="/QueryBuilder" state={{
            connectionName: connectionName,
            connectionType: connectionType,
            reportName: reportNameValue,
            catalogs: location.state.dropdownCatalogs,
            schemas: location.state.dropdownSchemas,
            tables: location.state.dropdownTables,
            columns: location.state.dropdownColumns

          }}>Home</Link>
        </>

      ) : null}
      <TableGrid

        connectionNameVal={connectionName}
        reportNameVal={reportNameValue}
        gridDataValue={gridDataValue}
        gridDataColumnsValue={gridDataColumnsValue} />
    </div>
  );
};

export default DataTableGrid;
